module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0040.png.0cfc3c7d.jpg";